var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.elementType.generalFormComponent,{key:_vm.element.id,ref:"panelForm",tag:"component",staticClass:"element-form",attrs:{"default-values":_vm.defaultValues},on:{"values-changed":function($event){return _vm.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }